/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortform_ReplacementsInputs */

const en_shortform_replacements = /** @type {(inputs: Shortform_ReplacementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shortform Replacements`)
};

const fr_shortform_replacements = /** @type {(inputs: Shortform_ReplacementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remplacements de formes abrégées`)
};

const de_shortform_replacements = /** @type {(inputs: Shortform_ReplacementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kurzformen für Ersetzungen`)
};

const it_shortform_replacements = /** @type {(inputs: Shortform_ReplacementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sostituzioni abbreviate`)
};

const ru_shortform_replacements = /** @type {(inputs: Shortform_ReplacementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Замена коротких форматов`)
};

const es_shortform_replacements = /** @type {(inputs: Shortform_ReplacementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reemplazos de formato corto`)
};

const zh_cn2_shortform_replacements = /** @type {(inputs: Shortform_ReplacementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`简短的替代方案`)
};

const ja_shortform_replacements = /** @type {(inputs: Shortform_ReplacementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`短縮形の置換`)
};

const hi_shortform_replacements = /** @type {(inputs: Shortform_ReplacementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संक्षिप्त प्रतिस्थापन`)
};

const pt_pt2_shortform_replacements = /** @type {(inputs: Shortform_ReplacementsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Substituições de formato abreviado`)
};

/**
* | output |
* | --- |
* | "Shortform Replacements" |
*
* @param {Shortform_ReplacementsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortform_replacements = /** @type {((inputs?: Shortform_ReplacementsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortform_ReplacementsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortform_replacements(inputs)
	if (locale === "de") return de_shortform_replacements(inputs)
	if (locale === "it") return it_shortform_replacements(inputs)
	if (locale === "ru") return ru_shortform_replacements(inputs)
	if (locale === "es") return es_shortform_replacements(inputs)
	if (locale === "zh-CN") return zh_cn2_shortform_replacements(inputs)
	if (locale === "ja") return ja_shortform_replacements(inputs)
	if (locale === "hi") return hi_shortform_replacements(inputs)
	if (locale === "pt-PT") return pt_pt2_shortform_replacements(inputs)
	return en_shortform_replacements(inputs)
});